// extracted by mini-css-extract-plugin
module.exports = {"container":"PrimaryDashboardButton_container__ps7sg"};